import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    selectIsMadeForYouWidget,
    selectTabList,
} from '~scenes/madeforyou/app/selectors/mfySelectors';
import {
    MADE_FOR_YOU_BASE_URL,
    MADE_FOR_YOU_WON_TYPE,
    MADE_FOR_YOU_BACKED_TYPE,
    MADE_FOR_YOU_FOR_TODAY_TYPE,
    MADE_FOR_YOU_GTM_HOMEPAGE,
    MADE_FOR_YOU_GTM_MADE_FOR_YOU,
    MADE_FOR_YOU_GTM_HOMEPAGE_MAP,
    MADE_FOR_YOU_GTM_MADE_FOR_YOU_MAP,
    MADE_FOR_YOU_TYPES,
} from './constants';
import {
    seoUrlRecentlyWon,
    seoUrlRecentlyBacked,
    seoUrlForToday,
} from '~spa/Utils/SeoUrls';
import i18n from '../../shared/utils/i18n';
import {
    initReduxState,
} from '~scenes/madeforyou/app/actions/mfyActions';

/**
 * Generates the SEO url accordingly to the given recommendation type.
 * @param {String} type recommendation type.
 * @returns {void}
 */
export const generateMfySeoUrl = (type) => {
    switch (type) {
        case MADE_FOR_YOU_BACKED_TYPE:
            return seoUrlRecentlyBacked(`${MADE_FOR_YOU_BASE_URL}/${i18n.t('url.madeforyou_backed')}`);
        case MADE_FOR_YOU_FOR_TODAY_TYPE:
            return seoUrlForToday(`${MADE_FOR_YOU_BASE_URL}/${i18n.t('url.madeforyou_fortoday')}`);
        case MADE_FOR_YOU_WON_TYPE:
        default:
            return seoUrlRecentlyWon(`${MADE_FOR_YOU_BASE_URL}/${i18n.t('url.madeforyou_won')}`);
    }
};

/**
 * Get the prefix of gtm, depends on the current tab and which page it is on.
 * @param {String} activeTab current tab
 * @param {Boolean} isWidget is widget
 * @returns {void}
 */
export const getGtmPrefix = (activeTab, isWidget) => {
    const eventCategory = isWidget ? MADE_FOR_YOU_GTM_HOMEPAGE : MADE_FOR_YOU_GTM_MADE_FOR_YOU;
    const eventAction = isWidget
        ? MADE_FOR_YOU_GTM_HOMEPAGE_MAP[activeTab]
        : MADE_FOR_YOU_GTM_MADE_FOR_YOU_MAP[activeTab];

    return `${eventCategory};${eventAction};`;
};

/**
 * Returns true when made for you is ready.
 * @param {Object} variables used to determine if view is ready.
 * @returns {Boolean} is ready to load.
 */
export const useMFYReady = ({isWidget = false}) => {
    const dispatch = useDispatch();
    const _isWidget = useSelector(selectIsMadeForYouWidget);
    const tabList = useSelector(selectTabList);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // initialise made for you redux state.
        dispatch(initReduxState(isWidget));
    }, []);

    useEffect(() => {
        if(!isReady) {
            const isWidgetStatusReady = isWidget === _isWidget;
            // We need to check that all the tabs are there before
            // We render so that we don't send an extra request on load.
            // The max requests we make on load should be 2.
            const isTabsReady = tabList.length === MADE_FOR_YOU_TYPES.length;
            setIsReady(isWidgetStatusReady && isTabsReady);
        }
    }, [_isWidget, tabList]);

    return isReady;
};
